module.exports = __webpack_public_path__ + "img/currency.cf6f7ccd.svg";